import { LocalizationService } from 'src/app/shared/services/localization.service';
import { DefectLocationVM } from 'src/app/view/defects/service/models/defect-view-models';
import { ArrHlp } from 'src/lib/fliko/helpers/array.helper';
import { StrHlp } from 'src/lib/fliko/helpers/string.helper';

export type PublicDefectStatusRouteData = {
  defectId: string;
  code: string;
};

export function buildPublicDefectStatusUrl(origin: string, defectId: string, code: string): string {
  const url = new URL('/defect/status', origin);

  url.searchParams.set('defectId', defectId);
  url.searchParams.set('code', code);

  return url.toString();
}

export function parsePublicDefectStatusRouteData(queryParams: Record<string, unknown>): PublicDefectStatusRouteData | null {
  const getParam = (key: keyof PublicDefectStatusRouteData): string | null => {
    const value = ArrHlp.get(queryParams[key], 0);
    return typeof value === 'string' ? StrHlp.trimToNull(value) : null;
  };

  const defectId = getParam('defectId');
  const code = getParam('code');

  return defectId && code ? { defectId, code } : null;
}

export function toLocalizedSummaryDetail(
  labelKey: string,
  value: string | null | undefined,
  ls: LocalizationService
): string | null {
  return value ? `${StrHlp.capitalize(ls.translate(labelKey))}: ${formatLocalizedLocationValue(value, ls)}` : null;
}

export function formatLocalizedLocationValue(value: string, ls: LocalizationService): string {
  return value === DefectLocationVM.ALL ? ls.translate('select.allF') : value;
}
